import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const ContactUs = () => {
     useEffect(() => {
        document.title = 'Contact Us -  Mary Matha Cmi  Academy';   
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
        <li><Link to="/"> Home</Link> </li> 
        <li>Contact Us </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Contact Us  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12 text-center">
            <p> <b>MARY MATHA CMI ACADEMY</b> <br/>  D.No. 224/B, Perumalkoilpatti, Devadanapatti, Periyakulam Taluk, 
            Theni – 625602, Tamilnadu.  <br/>
           
            <b> Phone:</b> +918056851655, +91 8015471655<br/>
            <b> Email:</b> mmcmiacademy@gmail.com</p>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default ContactUs
